import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { en } from 'Shared/Translation/Infrastructure/Translation/en';
import { es } from 'Shared/Translation/Infrastructure/Translation/es';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      es: { translation: es }
    },
    lng: 'es', // Idioma predeterminado
    fallbackLng: 'es', // Idioma de respaldo
    interpolation: {
      escapeValue: false // React ya cubre XSS
    }
  });

export default i18n;